// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__265hr","label":"styles_label__1nalP"};